var digistorm = {

    init: function () {

        // helper for iOS issues
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

        // load nav
        this.nav();


        // load tabs
        this.tabs();
        this.accordions();

        // load videos
        this.videos.init();

        // load carousel
        this.slick();


        // load calendars
        this.calendars();
        this.events();

        this.forms();

        this.popups();
        this.analytics();

        this.employment();

        this.newsletters();
    },

    nav: function () {
        // find any navbar burger buttons
        $('.navigation').find('.navbar-burger').click(function (e) {
            e.preventDefault();

            // find specified navbar
            target = $(this).attr('data-target')

            if (target.length) {
                // toggle active class on burger button
                $(this).toggleClass('is-active');

                // toggle active class on specified menu
                $('#' + target).toggleClass('is-active');
            }
        });

        // find any navbar search buttons
        $('.navigation').find('.search-button').click(function (e) {
            e.preventDefault();

            // find specified navbar
            target = $(this).attr('data-target')

            if (target.length) {
                // toggle active class on specified element
                $('#' + target).toggleClass('is-active');

                if ($('#' + target).is('.is-active')) {
                    $('input.search').focus();
                } else {
                    $('input.search').blur();
                }
            }
        });

    },

    videos: {

        init: function() {

            var _self = this;

            // check if there is a video player wrapper
            if ($('.video-player').length) {
                $('.video-player').each(function() {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel();
        },

        controls: function() {
            // initialise video controls

            $('.video-carousel .banner .control-pause').click(function () {
                $player = $(this).closest('.banner').find('.video-player');
                switch (digistorm.videos.togglePlay($player)) {
                    case 'no-data':
                        break;
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause');
                        break;
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play');
                        break;
                }
            });
    
            $('.video-carousel .banner .control-vol').click(function () {
                $player = $(this).closest('.banner').find('.video-player');
                switch (digistorm.videos.toggleMute($player)) {
                    case 'no-data':
                        break;
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up');
                        break;
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off');
                        break;
                }
            });
        },

        carousel: function() {
            // handle videos inside slick carousels
            $('.video-carousel').on('init', function(event, slick) {
                // mark carousel as initialized
                slick.is_initialized = true;
            }).on('setPosition', function(event, slick) {
                // synchronize slides with videos

                if (slick.is_initialized) {
                    // the slide up next
                    var $newSlide = $(slick.$slides[slick.currentSlide]);

                    // pause others
                    $newSlide.closest('.video-carousel').find('.banner').not($newSlide).find('.video-player').each(function(i, e) {
                        if (digistorm.iOS) {
                            // currently there's a bug with plyr where pause won't work on iOS
                            digistorm.videos.stopVideo($(e));
                        } else {
                            digistorm.videos.pauseVideo($(e));
                        }
                    });

                    // play new slide
                    var video = $newSlide.find('.video-player');
                    digistorm.videos.playVideo(video);
                    if (video.data() && video.data().player) {
                        // This slide is a video, pause slick autoslide
                        slick.$slider.slick('slickPause');
                    } else {
                        // This slide is not a video, resume slick autoslide
                        slick.$slider.slick('slickPlay');
                        $(".circleProgress").css('animation-duration', 5.9 + 's');
                    }
                }
            });
        },

        loadVideo: function(el) {
            // load a video element

            // get each config attr from this element
            var settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            var player = $(el).find('.player')

            var plyr = new Plyr(player[0], settings)
            // set up each video
            $(el).data({
                player: plyr
            });

            // if a carousel video, go to the next slide on video end
            var $carousel = $(el).closest('.video-carousel');
            if ($carousel.length) {
                
                if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', function(event) {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart();
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext');
                            }
                        }
                    });
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', function (event) {
                        $carousel.slick('slickNext');
                    });
                }

                plyr.on('playing', function() {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause');
                });
                plyr.on('pause', function() {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause');
                });
            }

            if (settings.muted && settings.autoplay) {
                digistorm.videos.attemptPlay(plyr);
            }
        },

        attemptPlay: function(player, count) {
            // attempts to play the video multiple times in case element is still loading

            if (!Number.isInteger(count)) {
                count = 0;
            }
        
            player.volume = 0;
            player.muted = true;
            player.play();
            if (count < 15) {
                setTimeout(function() {
                    if (!player.playing) {
                        count++;
                        digistorm.videos.attemptPlay(player, count);
                    }
                }, 1000);
            }
        },

        playVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.play()
            }

        },
        pauseVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing;
            }
            return 'no-data';
        },
        toggleMute: function($el) {
            if ($el.data() && $el.data().player) {
                player = $el.data().player;
                if (player.volume == 0) {
                    player.volume = 1;
                    return true;
                } else {
                    player.volume = 0;
                    return false;
                }
            }
            return 'no-data';
        }
    },

    slick: function () {

        // initialise banners
        console.log($('.banners'));
        $('.banners').slick({
            arrows: false,
            autoplaySpeed: 4000,
        })

        // load basic slick on all basic slicks
        $('.gallery.is-basic').find('.slick').slick()
        $('.gallery.is-basic').find('.slick').slickLightbox({
            src: 'src',
            itemSelector: '.slick-image img',
            caption: 'caption',
        })

        // load basic slick on all full galleries
        $('.gallery.is-full').find('.slick').slick()

        // lightbox config
        $('.gallery.is-lightbox').find('ul').slickLightbox({
            itemSelector: '> li > a'
        })

        $('.gallery.is-lightbox .more-s').click(function (e) {
            e.preventDefault();
            $(this).closest('.is-lightbox').find('.is-hidden:first a').click();
        })
    },

    tabs: function () {
        var _self = this;

        // transform tabs into work of magic
        $('.tabs').find('.tab-title').click(function() {
            // get the relative tabs
            var $tabs = $(this).closest('.tabs')
            var activeIndex = $(this).index()

            // remove active class from all tabs
            $tabs.find('.tab-title').removeClass('is-active')
            $tabs.find('.tab-content').removeClass('is-active')

            // add active to current tab
            $(this).addClass('is-active')
            $tabs.find('.tab-content').eq(activeIndex).addClass('is-active')
        });
    },

    accordions: function() {
        // accordions
        $('.tabs.style-accordion').each(function () {
            var $group = $(this);

            $('.accordion-wrapper .accordion-header', $group).click(function() {
                var $wrapper = $(this).closest('.accordion-wrapper')
                var wasActive = $wrapper.hasClass('is-active');

                // close the accordions
                $group.find('.accordion-wrapper').removeClass('is-active')
                $group.find('.accordion-content').css({ 'max-height': 0 })

                // if the accordion was active then lets just close it
                if (wasActive) {
                    return true
                }

                // get relative height needed to show the content
                var height = $wrapper.find('.tab-content').outerHeight()

                // open the accordion
                $wrapper.addClass('is-active')
                $wrapper.find('.accordion-content').css({ 'max-height': height + 'px' })
            });
        });
    },

    calendars: function () {
        var _self = this;

        $('[data-calendars]').each(function() {
            var calendarUrl = $(this).attr('data-calendar-url');
            var calendarTimezone = $(this).attr('data-calendar-timezone');

            $('.calendar-desktop').fullCalendar({
                events: function (start,end,timezone,callback) {
                    var url = calendarUrl + "&start=" + start.unix() + "&end=" + end.unix()
                    $('.calendar-desktop-loading-indicator').addClass('show');
                    $.ajax({url: url}).done(function (response){
                        $('.calendar-desktop-loading-indicator').removeClass('show');
                        callback(response)
                    });
                },
                eventDataTransform: function (e) {
                    e.start = moment.tz(parseInt(e.start_time) * 1000, calendarTimezone).format();
                    if (e.end_time != null) {
                        e.end = moment.tz(parseInt(e.end_time) * 1000, calendarTimezone).format();
                    }
                    if (e.all_day != null) {
                        e.allDay = e.all_day;
                    }
                    return e;
                },
                editable: false,
                timeFormat: 'h:mm A',
                eventClick: function (event, jsEvent, view) {

                    var $target = $(jsEvent.target)
                    var $event = $target.closest('.fc-event-container');
                    var $modal = $event.find('.cal-modal');

                    if (!$target.closest('.cal-modal').length) { // if not clicking the modal
                        if (!$modal.length) { // add the modal if it doesn't exist

                            $modal = _self.createEventModal(event, calendarTimezone);
                            $event.append($modal);

                            setTimeout(function () {
                                $modal.addClass('active')
                            }, 100);
                        } else {
                            $modal.addClass('active');
                        }
                    }
                }
            });

            $('.calendar-mobile').digistormMobileCalendar({
                url: calendarUrl,
                timezone: calendarTimezone
            });
        })
    },

    events: function () {
        var _self = this;
        $('[data-events-load]').each(function() {
            var calendarUrl = $(this).attr('data-calendar-url');
            var calendarTimezone = $(this).attr('data-calendar-timezone');

            var block = $('.events-wrapper', this);
            var limit = 6;

            $.ajax({
                url: calendarUrl,
                data: {
                    start: Math.floor(Date.now() / 1000),
                    limit: limit
                },
                dataType: 'json',
                success: function (events) {
                    var eventsClone = $('<div class="event"><div class="event-date"><div class="event-date"></div></div><div class="event-details"><h3 class="event-title"></h3><small class="event-time"></small></div></div>');

                    events.sort(function(x, y){
                        return  x.start_time - y.start_time;
                    });

                    $.each(events, function (index, event) {
                        // stop loop
                        if (index >= limit) {
                            return false;
                        }

                        var newClone = eventsClone.clone(true);
                        var mStart = moment.tz(parseInt(event.start_time) * 1000, calendarTimezone);
                        var mEnd = moment.tz(parseInt(event.end_time) * 1000, calendarTimezone);

                        newClone.find('.event-date').text(mStart.format('D MMMM'));

                        if (event.allDay) {
                            newClone.find('.event-time').text('all day event');
                        } else {
                            if (event.start_time == event.end_time) {
                                newClone.find('.event-time').text(mStart.format('h:mm a'));
                            } else {
                                newClone.find('.event-time').text(mStart.format('h:mm a') + ' - ' + mEnd.format('h:mm a'));
                            }
                        }

                        newClone.find('.event-title').text(event.title);
                        block.append(newClone);

                        newClone.click(function () {
                            var modal = newClone.data('modal');
                            if (!modal) {
                                modal = _self.createEventModal(event).appendTo($('body'), calendarTimezone);
                                newClone.data('modal', modal);
                            }

                            setTimeout(function () {
                                modal.addClass('active')
                            }, 100);
                        });
                    });

                    $('.event-block', block).each(function () {
                        $(this).addClass('blocks-' + $(this).find('.event').length);
                        $(this).find('.event').wrapAll('<div class="events-block-inside"></div>');
                    });
                }
            })
            .fail(function () {
                block.html('<p class="error"><strong>Unknown error</strong></p>');
            })
            .always(function () {
                block.addClass('events-loaded');
            });
        })
    },

    // create modal from reach event
    createEventModal: function (event, calendarTimezone) {
        $modal = $('<div class="cal-modal"></div>');
        var $holder = $('<div class="content-holder"></div>')
        var $content = $('<div class="content"></div>');

        $content.append('<h2>' + event.title + '</h2>');

        if (typeof calendarTimezone == 'undefined') {
            calendarTimezone = event.timezone;
        }

        var mStart = moment.tz(parseInt(event.start_time) * 1000, calendarTimezone);
        var mEnd = moment.tz(parseInt(event.end_time) * 1000, calendarTimezone);

        if (mStart.isSame(mEnd,'day')) {
            if (event.allDay) {
                $content.append('<small>'+mStart.format('D MMMM')+' (All Day)</small>');
            } else {
                $content.append('<small>'+mStart.format('D MMMM')+' (' + mStart.format('h:mma') + ' - ' + mEnd.format('h:mma') + ')</small>');
            }
        } else{
            $content.append('<small>' + mStart.format('D MMM') + ' - ' + mEnd.format('D MMM') + '</small>');
        }
        $content.append('<p>' + event.body + '</p>');

        if (event.attachments && event.attachments.length) {
            $.each(event.attachments, function (i, attachment) {
                switch (attachment.type) {
                    case 'address':
                        $content.append('<div class="attachment attachment-address"><i class="fa fa-map-marker"></i> ' + String(attachment.address).replace("\n", '<br>') + '</div>');
                        break;
                    case 'contact':
                        var contact_details = [];
                        if (attachment.contact_name) {
                            contact_details.push(attachment.contact_name);
                        }
                        if (attachment.contact_phone) {
                            contact_details.push($('<a>').attr('href', 'tel:' + attachment.contact_phone ).text(attachment.contact_phone ).prop('outerHTML'));
                        }
                        if (attachment.contact_email) {
                            contact_details.push($('<a>').attr('href', 'mailto:' + attachment.contact_email ).text(attachment.contact_email ).prop('outerHTML'));
                        }
                        $content.append('<div class="attachment attachment-contact"><i class="fa fa-phone"></i> ' + contact_details.join('<br>') + '</div>');
                        break;
                    case 'link':
                        $content.append('<div class="attachment attachment-link"><i class="fa fa-link"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.url).prop('outerHTML')  + '</div>');
                        break;
                    case 'file':
                        $content.append('<div class="attachment attachment-file"><i class="fa fa-file"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.file_name).prop('outerHTML') + '</a></div>');
                        break;
                }
            });
        }

        $modal.click(function (event) {
            if ($(event.target).hasClass("cal-modal") || $(event.target).hasClass("close") || $(event.target).hasClass("content-holder")) {
                $(this).removeClass('active');
            }
        });

        $holder.append('<div class="close">CLOSE</div>');
        $holder.append($content);
        $modal.append($holder);

        return $modal;
    },

    forms: function () {
        // Send google analytics event on form submission
        $('[data-form-name] form').on('submit', function () {
            var formWrapper = $(this).closest('[data-form-name]');
            if (window.ga) {
                ga('send', 'event', formWrapper.attr('data-form-name'), formWrapper.attr('data-form-page'));
            }
        });
        $('form').on('submit', function() {
            const submitContainer = $(this).find('.form-item.form-submit');
            submitContainer.html('<button class="form-submit-btn submitting" type="submit" disabled>Submit form<div></div><div></div><div></div></button>');
        });
        $('input[name$="[date]"]').datepicker({
            format: "dd/mm/yyyy"
        });
        $('input[name$="[date]"]').attr("placeholder", "dd/mm/yyyy");
        $('input[name$="[time]"]').timepicker({
            timeFormat: 'h:mm p',
            interval: 30,
            dynamic: true,
            dropdown: true,
            scrollbar: true
        });
        $('input[name$="[time]"]').attr("placeholder", "10:30 AM");
    },

    popups: function() {
        $('.action-modal').each(function() {
            var modal = $(this)
            var key = 'modal-' + modal.data('key')
            var cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#wrapper').addClass('action-modal-active')

                var image = modal.find('img')
                var imageHeight = image.outerHeight()
                $('#wrapper').css('paddingTop', imageHeight)
                image.on('load', function() {
                    var imageHeight = this.outerHeight()
                    $('#wrapper').css('paddingTop', imageHeight)
                })
                $(window).on('resize', function() {
                    var imageHeight = image.outerHeight()
                    $('#wrapper').css('paddingTop', imageHeight)
                })

                modal.find('.close-action-modal').click(function() {
                    modal.addClass('delete')
                    modal.removeClass('active')
                    $('#wrapper').removeClass('action-modal-active')
                    Cookies.set(key, 'viewed', { expires: 5 })
                })
                modal.find('.action-modal-background').click(function() {
                    modal.removeClass('active')
                })
            }
        });
    },

    analytics: function () {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            var domain = String(window.location.host).replace(/^www\./, '');
            var openInNewWindow = $(this).attr('target') == '_blank';
            var url = $(this).attr('href');

            // Find the domain of the link. Works with http, https and protocol-less urls
            var linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^\/\s]+)/);
            if (linkAnatomy) {
                var linkDomain = linkAnatomy[3];

                // Check if google analytics is loaded and the url is external
                if (window.ga && domain != linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url);

                    // If the link will open in this window we should delay navigation until the event is sent
                    if (!openInNewWindow && !e.isDefaultPrevented()) {
                        e.preventDefault();

                        // Push the navigation onto the queue (will be processed after event is sent)
                        ga(function () {
                            // Navigate to url
                            window.location.href = url;
                        })

                        return false;
                    }
                }
            }
        });
    },
    employment: function() {
        $('.employment-application-form').each(function(i,e) {
            var $form = $(e);
            var jobTitle = $form.data('job-title');
            console.log(jobTitle);
            $form.find('input[id$="wf-applyingFor-1"]').val(jobTitle);
        });
    },
    newsletters: function(){


        $('.newsletter-sidebar-desktop').theiaStickySidebar({
            minWidth: 1024,
            additionalMarginTop: 100
        });

        $('.newsletter-events .events-wrapper').each(function() {
            var articles_wrapper = $(this);
            if ($(articles_wrapper).find('div').length == 0) {
                $(".newsletter-events-header").hide();
            }
        })

        $('.newsletter-archive-wrap .show-newsletter-archive').click(function() {
            $(this).hide();
            $('.newsletter-archive-wrap .newsletter-archive-reach').show();
        });

        //Newsletter section

        $('.newsletter-article-expandable').css({ 'max-height': '320px' })

        $('.newsletter-article').find('.newsletter-article-expand').click(function() {

            var $article = $(this).parent()
            var $expandable = $article.find('.newsletter-article-expandable')
            var $content = $article.find('.newsletter-article-content')

            // toggle class
            $article.toggleClass('is-active')

            // set height to article size
            var height = $content.outerHeight() + 20;
            $expandable.css({ 'max-height': height + 'px' })

            if ($article.hasClass('is-active')) {
                // allow any height after animation done
                setTimeout(function() {
                    if ($article.hasClass('is-active')) {
                        $expandable.css({ 'max-height': 'none' })
                    }
                }, 300)
            } else {
                    // if collapsing article set max height
                    setTimeout(function() {
                    if (!$article.hasClass('is-active')) {
                        $expandable.css({ 'max-height': '320px' })
                    }
                }, 100)
            }

        });


        $('.newsletter-expand-all').click(function() {
            var $articles    = $('.newsletter-article');
            var $expandables = $('.newsletter-article-expandable');

            if ($(this).hasClass('is-expanded')) {
                $articles.removeClass('is-active');
                $expandables.css({'max-height': '320px'});
            } else {
                $articles.addClass('is-active');
                $expandables.css({'max-height': 'none'});
            }

            $(this).toggleClass('is-expanded');
        });

        $('.newsletter-toggle').click(function() {
            $(this).find('.toggle-nav-newsletter').toggleClass("cross");
            $(".newsletter-sidebar").toggleClass("open-sidenav");
        });

        $(".article-title, .article-sub-title").click(function() {
            var target = $($(this).attr('data-attr'));
            $('html, body').animate({
                    scrollTop: (target.offset().top) - 200
            }, 800);
            var window_width = $(window).width();
            if (window_width < 1023) {
                $(".toggle-nav-newsletter").toggleClass("cross");
                $(".newsletter-sidebar").toggleClass("open-sidenav");
            }
        });

        var window_width = $(window).width();
        if (window_width > 1023) {
            if ($(".toggle-nav-newsletter").hasClass('cross')){
                $(".toggle-nav-newsletter").removeClass('cross');
            }
            if ($(".newsletter-sidebar").hasClass('open-sidenav')){
                $(".newsletter-sidebar").removeClass('open-sidenav')
            }
        }
    },

}

// Yo!
$(document).ready(function () {
    digistorm.init();
});

